import React from "react";
import { reasons } from "../../App/Landing/landingContent";
import { Icon } from "./Icon";
import Reveal from "./Reveal";

export default function WhyChoose() {
  return (
    <section id="why" className="bg-brand-mist py-14 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500">Why choose BudgetPrintPros</p>
          <h2 className="display mt-2 text-3xl sm:text-4xl">Quality Prints. Prices You'll Love.</h2>
        </Reveal>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-slate-200">
          {reasons.map((r, i) => (
            <Reveal key={r.title} delay={i * 110} className={`flex items-start gap-4 lg:px-6 ${i === 0 ? "first:lg:pl-0" : ""}`}>
              <Icon name={r.icon} className="h-12 w-12 shrink-0 text-brand" />
              <div>
                <h3 className="text-sm font-bold">{r.title}</h3>
                <p className="mt-1 text-sm text-slate-700 leading-relaxed">{r.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
